'use strict';

module.exports = {
  template: require('./users-navigation.html'),
  controller: require('./users-navigation.controller.js'),
  controllerAs: 'vm',

  bindings: {
    titleText: '@',
    leadText: '@',
    unwindUrl: '@'
  }
};



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/admin/users/users-navigation/index.js
 ** module id = 162
 ** module chunks = 0
 **/